import { FC, PropsWithChildren } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

import { SignInWithTokenState, useSignInWithToken } from '@/hooks/useSignInWithToken';
import { useAuth, useUser } from '@/lib/auth';
import { NotFoundPage } from '@/pages/not-found';

export const StaffSignedInRoute: FC = () => {
  return (
    <RequireAuth>
      <RequireStaffRole>
        <Outlet />
      </RequireStaffRole>
    </RequireAuth>
  );
};

export const RequireAuth: FC<PropsWithChildren> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const { isSignedIn } = useAuth();
  const { signInState } = useSignInWithToken(searchParams.get('token'));

  if (signInState === SignInWithTokenState.SUCCESS || isSignedIn) {
    return <>{children}</>;
  }

  return <NotFoundPage disableLogging />;
};

export const RequireStaffRole: FC<PropsWithChildren> = ({ children }) => {
  const isStaff = useUser().is_staff;

  if (!isStaff) throw new Error(`Expected staff membership, but "${isStaff} staff member"`);

  return <>{children}</>;
};
